import React from 'react';

interface InfoTooltipProps {
  text: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => {
  return (
    <span className="relative inline-flex items-center group">
      <svg
        className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-help"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-150 absolute top-full left-0 mt-2 w-72 px-3 py-2 text-xs text-white bg-gray-800 rounded-lg shadow-lg z-[100] pointer-events-none leading-relaxed">
        {text}
        <span className="absolute bottom-full left-3 border-4 border-transparent border-b-gray-800" />
      </span>
    </span>
  );
};

export default InfoTooltip;
